import React from 'react';
import { Box, Stack, StackProps, styled } from '@mui/material';

export const ImageSize = 36;
const MarginSize = 12;

export const Wrapper = styled(({ children, ...props }: StackProps) => (
  <Stack {...props}>{children}</Stack>
))(() => ({
  position: 'relative',
  width: '100%',
  padding: '0 8px',
  '.profile-image': {
    borderRadius: '100%',
    objectFit: 'cover',
    cursor: 'pointer',
  },
  'button.like': {
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 'auto',
    padding: '4px 8px',
    height: '28px',
    borderRadius: '14px',
    gap: '2px',
    fontWeight: 400,
    svg: { width: '20px', height: '20px' },
    border: '1px solid var(--dk-line, #E7E9EC)',
    background: 'var(--dk-bg, #fff)',

    '& .likeCount': {
      color: 'var(--dk-text-secondary, #888D96)',
    },

    '&.isLiked': {
      border: '1px solid var(--dk-accent, #06C)',
      background: 'rgba(0, 102, 204, 0.1)',

      '& .likeCount': {
        color: 'var(--dk-accent, #06C)',
      },
    },

    ':hover': {
      background: 'var(--dk-bg-muted, #F3F5F6)',
    },
  },
  'button.line': {
    display: 'inline-flex',
    alignItems: 'center',
    flexDirection: 'row',
    minWidth: 'auto',
    padding: '4px 0',
    height: '28px',
    borderRadius: '14px',
    gap: '2px',
    fontWeight: 400,

    ':hover': {
      background: 'var(--dk-bg-muted, #F3F5F6)',
    },

    '& .line-text': {
      color: 'var(--dk-text-secondary, #888D96)',
      textDecoration: 'underline',
    },
  },
  'button.translate': {
    display: 'flex',
    padding: '0 2px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    minWidth: 'auto',

    '& .translate-text': {
      color: 'var(--dk-text-secondary, #888D96)',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      textDecoration: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkipInk: 'none',
      textDecorationThickness: 'auto',
      textUnderlineOffset: 'auto',
      textUnderlinePosition: 'from-font',
    },

    ':hover': {
      background: 'transparent',
      '& .translate-text': {
        color: 'var(--dk-accent, #06C)',
      },
    },
  },
  '.translating-text': {
    color: 'var(--dk-text-secondary, #888D96)',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    padding: '0 2px',
  },
  img: {
    maxWidth: '100%',
  },

  '& .name-position': {
    color: 'var(--dk-text, #000)',
    fontWeight: 500,
    marginLeft: `${MarginSize}px`,
  },

  '& .createdAt': {
    marginLeft: 'auto',
    color: 'var(--dk-text-dim, #B7BBC2)',
  },

  '& .list-wrapper': {
    paddingLeft: `${ImageSize + MarginSize}px`,
  },

  '& .attachment-wrapper': {
    marginTop: '12px',
    width: '320px',
    gap: '4px',
  },

  '&.isMobile': {
    '& .list-wrapper': {
      paddingLeft: 'initial',
    },

    '& .attachment-wrapper': {
      width: '100%',
    },
  },
}));

export const LoadingOverlay = styled(Box)`
  z-index: 1;
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  bottom: -8px;
  backdrop-filter: blur(3px);
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;
